import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden, Button } from '@mui/material'
import { styled } from '@mui/material/styles';

import MyModal from "../../ui/MyModal"

import LanguageContext from "../../../contexts/LanguageContext"

import cardIcon from "../../../images/cardIcon.svg"
import blockModalMapping1 from '../../../images/blockModal-mapping-1.png'
import blockModalMapping2 from '../../../images/blockModal-mapping-2.png'

const Card = ({ background, icon, title, subTitle }) => {
  return (
    <Box sx={{
      border:"1px solid #E7E7E7",
      flex:1,
      padding:"12px",
      display:"flex",
      flexDirection:"column",
      gap:["15px", "15px", "15px", "20px"]
    }}>
      <Box sx={{
        border:"1px solid #E7E7E7",
        background:background,
        backgroundSize : "cover",
        backgroundPosition : "center center",
        backgroundRepeat:"no-repeat",
        width:"100%",
        aspectRatio:"16/9",
      }}>
      </Box>
      <Box sx={{
        display:"flex",
        gap:["10px","10px","10px","15px"],
      }}>
        <Box sx={{
          width:["35px", "40px", "40px", "45px"],
          minWidth:["35px", "40px", "40px", "45px"],
        }}>
          <img src={icon} style={{width:"100%"}}/>
        </Box>
        <Box>
          <Box sx={{
            paddingBottom:"8px",
            color:"text.black",
            fontSize:["15px", "16px", "16px", "18px"],
          }}>
            {title}
          </Box>
          <Box sx={{
            color:"text.subTitle",
            fontSize:["12px", "13px", "13px", "14px"],
          }}>
            {subTitle}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const BlockModal = ({ open, onClose, type }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  let title = ""
  if (type === "mapping") { title = languageValues?.adminDashboard?.mapping[actLanguage] }
  if (type === "certification") { title = languageValues?.adminDashboard?.certification[actLanguage] }

  let subTitle = ""
  if (type === "mapping") { subTitle = languageValues?.adminDashboard?.blockModal?.subTitle?.mapping[actLanguage] }
  if (type === "certification") { subTitle = languageValues?.adminDashboard?.blockModal?.subTitle?.certification[actLanguage] }

  let textCard1 = ""
  if (type === "mapping") { textCard1 = languageValues?.adminDashboard?.blockModal?.card1?.mapping[actLanguage] }
  if (type === "certification") { textCard1 = languageValues?.adminDashboard?.blockModal?.card1?.certification[actLanguage] }

  let textCard2 = ""
  if (type === "mapping") { textCard2 = languageValues?.adminDashboard?.blockModal?.card2?.mapping[actLanguage] }
  if (type === "certification") { textCard2 = languageValues?.adminDashboard?.blockModal?.card2?.certification[actLanguage] }

  let backgroundCard1 = "#FAF8F6"
  let backgroundCard2 = "#FAF8F6"
  if (type === "mapping") {
    backgroundCard1 = `url(${blockModalMapping1})`
    backgroundCard2 = `url(${blockModalMapping2})`
  }


  return (
    <>

    <MyModal
      isOpen={open}
      maxWidth="md"
      onClose={onClose}
      title={title}
      subTitle={subTitle}
      topTitle={languageValues?.adminDashboard?.blockModal?.topTitle[actLanguage]}
    >
      <Box sx={{
        display:"flex",
        flexDirection:"column",
        flex:1,
        justifyContent:["space-between", "unset"],
        gap:"10px",
      }}>
        <Box sx={{
          display:"flex",
          flexDirection:["column", "row"],
          gap:["20px", "25px", "30px", "40px"],
        }}>
          <Card
            title={languageValues?.adminDashboard?.blockModal?.feature[actLanguage] + " #1"}
            subTitle={textCard1}
            background={backgroundCard1}
            icon={cardIcon}
          />
          <Card
            title={languageValues?.adminDashboard?.blockModal?.feature[actLanguage] + " #2"}
            subTitle={textCard2}
            background={backgroundCard2}
            icon={cardIcon}
          />
        </Box>
        <Box sx={{
          paddingTop:["0px", "30px"],
          textAlign:"center",
        }}>
          <Button
            size="large"
            type="submit"
            variant="contained"
            sx={{
              background:"rgba(226, 100, 56, 1)",
              '&:hover': {
                backgroundColor: "rgba(226, 100, 56, 0.8)",
              },
            }}
            onClick={() => {
              window.open('mailto:hello@risinguparis.com')
            }}
          >
            {languageValues?.adminDashboard?.blockModal?.button[actLanguage]}
          </Button>
        </Box>
      </Box>
    </MyModal>


    </>
  )
}


export default BlockModal
